import React, { useMemo } from 'react';
import { UseQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { CircularProgress, Link } from '@mui/material';
import { v4 as uuid } from 'uuid';

interface Interface {
  field: any;
  fieldName: string;
  query: UseQuery<any>;
  param?: string;
  hasLink?: string;
  linkField?: string;
  noApiSearch?: string;
}

const CellCustom: React.FC<Interface> = ({
  field,
  query,
  param,
  fieldName,
  hasLink,
  linkField,
  noApiSearch,
}) => {
  let arg = '';
  if (param) {
    arg = param + field;
  }
  const { data = [], isFetching, isError } = query(field === null ? '' : arg);

  const result = useMemo<Array<any>>(() => {
    if (Array.isArray(data) && data.length > 0) {
      if (noApiSearch) {
        const temp = data.find(item => item[noApiSearch] === field);
        if (temp) {
          return [temp];
        }
      } else {
        return data;
      }
    }

    return [];
  }, [isFetching, data]);

  if (field === null) {
    return <></>;
  }

  if (isFetching) {
    return <CircularProgress />;
  }

  if (isError) {
    return <span></span>;
  }

  return (
    <>
      {result.map(item => {
        if (hasLink) {
          return (
            <Link
              key={uuid()}
              display={'block'}
              href={linkField ? hasLink + item[linkField] : hasLink + field}
            >
              {item[fieldName]}
            </Link>
          );
        } else {
          return <p key={uuid()}>{item[fieldName]}</p>;
        }
      })}
    </>
  );
};

export default CellCustom;
